<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    <v-card class="box" v-if="ay_room_data != null">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>View Room Time Table</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center">
        <v-col sm="2" md="2" cols="12">
          <v-icon color="error">*</v-icon>
          <v-combobox rounded dense required v-model="current_academic_year" :items="ay_room_data.academic_year_list"
            item-text="Academic Year" label="Academic Year" outlined @change="get_rooms();getTimeTableVersion();tt_version = null;" persistent-hint
            hint="Please Select Academic Year" />
        </v-col>
        <v-col sm="2" md="3" cols="12">
          <v-icon color="error">*</v-icon>
          <v-combobox rounded dense required v-model="stream" :items="stream_list" item-value="id" item-text="name"
            label="Stream" outlined persistent-hint hint="Please Select Stream" />
        </v-col>
        <v-col sm="2" md="2" cols="12">
          <v-icon color="error">*</v-icon>
          <v-combobox rounded dense required v-model="classroom" :items="classroom_list" label="Classrooms" outlined
            persistent-hint hint="Please Select Classroom" />
        </v-col>
        <v-col sm="2" md="2" cols="12" v-if="current_academic_year">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="tt_version" :items="tt_version_list"
                        item-text="name" item-value="id" label="Version" outlined persistent-hint
                        hint="Please Select Version" />
        </v-col>
        <v-col sm="2" md="1" cols="12">
          <v-btn class="mt-6 button" :disabled="disabled" @click="getRoomTimeTable"
            :loading="fetch_btn_load">Fetch</v-btn>
        </v-col>
      </v-row>
      <!-- </v-card-text> -->
    </v-card>
    <!-- {{tt_list}} -->
    <v-card :loading="tt_load" class="box" v-if="tt_list != null">
      <!-- <v-card-title class="toolbar">
        <h3>Time Table</h3>
      </v-card-title> -->
      <!-- <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Time Table
                    </strong>
                </v-toolbar-title>
            </v-toolbar> -->
      <v-card v-if="tt_list != null" flat>
        <!-- <v-card-text> -->
        <!-- excel btn code -->
        <v-row dense>
            <v-btn rounded color="success" small outlined @click="fnExcelReport('my-table-id', 'RoomTT')" class="mb-2 ml-2"
              :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-row>
        <div id="my-table-id">
          <v-simple-table class="elevation-1 mytable" dense>
            <thead>
              <tr>
                <th style="background-color: #ffd699">
                  AY:{{ current_academic_year }}
                </th>
                <!-- <th  style="background-color: #b3d4fc;" v-for="s in slots" :key="s.id">{{s.start_time}}</th> -->
                <th class="toolbar" v-for="s in slots" :key="s.id">
                  {{ s.start_time }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tt in tt_list" :key="tt.id">
                <!-- <th  style="background-color: #b3d4fc;">{{tt[0].tt_day}}</th> -->
                <th width="10%" class="toolbar">
                  <center>{{ tt[0].tt_day }}</center>
                </th>
                <td v-for="data in tt" :key="data.id">
                  <!-- {{data}} -->
                  <v-btn v-if="data.toshowcompulsory == true" class="btn-grad" width="100%" small
                    :color="data.tt_slot_color"
                    :title="`Subject:${data.tt_course_tip} Std:${data.tt_std} Div:${data.tt_div} Room:${data.tt_room} Event:${data.tt_event_tip}`">
                    <span v-if="data.tt_course != null">
                      <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                      {{ data.tt_course }}
                    </span>
                    <a :href="data.tt_web_link" v-if="data.tt_web_link" target="_blank">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="white" v-bind="attrs" v-on="on" size="25">mdi mdi-link</v-icon>
                        </template>
                        <span> Webinar Link!!! </span>
                      </v-tooltip>
                    </a>
                    <span v-if="data.tt_room != null">
                      <v-icon color="blue" small>mdi-warehouse</v-icon>
                      {{ data.tt_room }}
                    </span>
                    <span v-if="data.tt_event != null">
                      <v-icon color="green" small>mdi-cricket</v-icon>
                      {{ data.tt_event }}
                    </span>
                    <span v-if="data.tt_div != null">
                      <v-icon color="#9808EB" small>mdi-standard-definition</v-icon>
                      {{ data.tt_std }}-{{ data.tt_div }}
                    </span>
                  </v-btn>
                  <span v-if="data.electives.length != 0">
                    <v-tooltip right color="#00DBDE" dark>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" width="100%" :id="data.tt_id"
                          v-for="(ele, index) in data.electives" :key="index" small class="pt-2 mt-2 btn1-grad"
                          :title="`Subject:${ele.ele_crs} Room:${ele.ele_room} Event:${ele.ele_event} Instructor:${ele.ele_instructor}`">
                          <span v-if="ele.ele_crs != null">
                            <v-icon small color="green">mdi-book-open-page-variant</v-icon>
                            {{ ele.ele_crs }}
                          </span>
                          <a :href="ele.ele_link" v-if="ele.ele_link" target="_blank">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="white" v-bind="attrs" v-on="on" size="20">mdi mdi-link</v-icon>
                              </template>
                              <span> Webinar Link!!! </span>
                            </v-tooltip>
                          </a>
                          <span v-if="ele.ele_room != null">
                            <v-icon color="blue" small>mdi-warehouse</v-icon>
                            {{ ele.ele_room }}
                          </span>
                          <span v-if="ele.ele_event != null">
                            <v-icon color="green" small>mdi-cricket</v-icon>
                            {{ ele.ele_event }}
                          </span>
                          <span v-if="ele.ele_instructor != '--'">
                            <v-icon color="#9808EB" small>mdi-account-tie</v-icon>
                            {{ ele.ele_instructor }}
                          </span>
                        </v-btn>
                      </template>
                      <span> Elective Time Table </span>
                    </v-tooltip>
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
        <!-- <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>
                                <strong>
                                    Slots
                                </strong>
                            </v-toolbar-title>
                        </v-toolbar>
                    <v-row v-if="slot_type.length!=0 && tt_list!=null">
                        <v-row class="pt-2" align="center" justify="center">
                            <span v-for="st in slot_type" :key="st.id">
                                <v-btn rounded class="mr-5" :color="st.color">{{st.type}}</v-btn>
                            </span>
                        </v-row>
                    </v-row>
                    </v-card> -->
      </v-card>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {

  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    loader: false,
    ay_room_data: null,
    current_academic_year: null,
    classroom_list: null,
    classroom: null,
    // extraBreadcrumbItems: [
 

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    fetch_btn_load: false,
    tt_list: null,
    slots: null,
    all_room_list: null,
    stream_list: [],
    stream: null,
    slot_type: null,
    tt_load: false,
    tt_version_list:[],
    tt_version:null
  }),
  mounted() {
    this.get_ay_rooms();
  },
  computed: {
    disabled() {
      return this.classroom_list == "No ClassRooms Available";
    },
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getTimeTableVersion() {
            const data = {
                ay: this.current_academic_year,
            };
            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.tt_version_list = res.data.tt_version_list;
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },
    get_ay_rooms() {
      axios
        .post("/TimeTable/get_ay_rooms")
        .then((res) => {
          if (res.data.msg == "200") {
            this.ay_room_data = res.data.data;
            this.classroom_list = res.data.data.classroom_list;
            this.current_academic_year = res.data.data.current_academic_year;
            if (this.current_academic_year) {
                    this.getTimeTableVersion();
                }
            this.stream_list = res.data.stream_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    get_rooms() {
      if (this.current_academic_year != null) {
        const formData = {
          ay: this.current_academic_year,
        };
        axios
          .post("/TimeTable/get_rooms", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              //console.log(res.data.data);
              this.classroom_list = res.data.data.rooms_list;
              if (this.classroom_list.length == 0) {
                //console.log(res);

                alert("No classrooms are offered!");
                this.classroom_list = ["No ClassRooms Available"];
                this.tt_list = null;
              } else if (this.classroom_list.length != 0) {
                //console.log(res);

                this.classroom_list = res.data.data.rooms_list;
              }
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
      }
    },
    getRoomTimeTable() {
      this.fetch_btn_load = true;
      this.tt_load = true;
      if (this.tt_version == null || this.stream == null || this.classroom == null) {
                this.showSnackbar("#b71c1c", "Please select Stream, Classroom and Time Table Version");
                this.tt_load = false;
                this.fetch_btn_load = false;
                return;
            }
      const data = {
        ay: this.current_academic_year,
        classroomNumber: this.classroom,
        stream: this.stream,
        tt_version:this.tt_version
      };
      axios
        .post("/TimeTable/getRoomTimeTable", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.tt_list = res.data.tt_list;
            this.slots = res.data.slot;
            this.slot_type = res.data.slot_type;
            this.all_room_list = res.data.rooms;
            //console.log(res);
            this.fetch_btn_load = false;
          } else {
            this.tt_list = null;
            alert(res.data.status_reason);
            this.fetch_btn_load = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.fetch_btn_load = false;
          this.tt_load = false;
        });
    },
    showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
  },
};
</script>
<style scoped>
/* table {
        border-collapse: collapse;
        font-size: 12px;
        border: 2px solid #cccccc;
        background-color: #ffffff;
    }
    th {
        border: 2px solid #cccccc;
        padding: 4px;
    }
    td:nth-child(odd) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    }
    td:nth-child(even) {
        width: 15em;
        padding: 4px;
        text-align: center;
        border: 2px solid #cccccc;
    } */
td,
th {
  border: 1px solid #ccc;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
  }
  td + td,
  th + th {
    width: auto;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
}

.btn-grad {
  /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
}
.btn-grad {
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: black;
  box-shadow: 0 0 20px rgb(190, 187, 187);
  border-radius: 10px;
  display: block;
}

.btn-grad:hover {
  background-position: right center; /* change the direction of the change here */
  color: black;
  text-decoration: none;
}
.btn1-grad {
  background-image: linear-gradient(
    to right,
    #085078 0%,
    #85d8ce 51%,
    #085078 100%
  );
}
.btn1-grad {
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  display: block;
}

.btn1-grad:hover {
  background-position: right center; /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
}
</style>
